<script setup>
import { computed, ref } from "vue";
import { useTextStore } from "@/stores/useTextStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

// ✅ adiciona "notify"
const emit = defineEmits(["close", "texts-deleted", "notify"]);
const store = useTextStore();

const selectedCount = computed(() => store.selectedTextIds.length);

// ✅ congela ao abrir (pra não trocar a mensagem durante o delete)
const frozenCount = ref(selectedCount.value);
if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;

const messageTitle = computed(() => {
  if (frozenCount.value === 1)
    return "Tem certeza que deseja excluir este texto?";
  return `Tem certeza que deseja excluir ${frozenCount.value} textos?`;
});

function buildBatchDeleteTextError(error) {
  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir os textos.";

  // Se quiser tratar FK depois, faz aqui.
  return raw;
}

async function onConfirmBatchDelete() {
  try {
    await store.deleteSelectedTexts();

    // ✅ pede para o PAI exibir toast de sucesso
    const successMessage =
      frozenCount.value === 1
        ? "Texto apagado com sucesso."
        : `${frozenCount.value} textos apagados com sucesso.`;

    emit("notify", {
      type: "success",
      message: successMessage,
    });

    // mantém comportamento original
    emit("texts-deleted");
    emit("close");
  } catch (error) {
    const msg = buildBatchDeleteTextError(error);

    // ✅ pede para o PAI exibir toast de erro
    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Textos em Lote"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-los serão excluídas também todas as Atividades e Notas vinculadas a eles. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmBatchDelete"
    @close="emit('close')"
  />
</template>
